export default __webpack_public_path__ + "static/media/LAS0990.34I-43103_-25768_0.17da1633.jpg";